import BreadCrumbItem from './BreadCrumbItem'
import {Row, Col} from 'reactstrap'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';

const BreadCrumb = (props) => {

    const order = localStorage.getItem("Age") > 15 ? [
        {link : "/information", name: "BREADCRUMB1"},
        {link : "/personal-details", name: "BREADCRUMB2"},
        {link : "/family", name : "BREADCRUMB3"},
        {link : "/job", name : "BREADCRUMB4"},
        {link : "/circumstances", name : "BREADCRUMB5"},
        {link : "/consequences", name : "BREADCRUMB6"},
        {link : "/intervention", name : "BREADCRUMB7"},
        {link : "/remark", name : "BREADCRUMB8"}
        ] : [
        {link : "/information", name: "BREADCRUMB1"},
        {link : "/personal-details", name: "BREADCRUMB2"},
        {link : "/family", name : "BREADCRUMB3"},
        {link : "/circumstances", name : "BREADCRUMB5"},
        {link : "/consequences", name : "BREADCRUMB6"},
        {link : "/intervention", name : "BREADCRUMB7"},
        {link : "/remark", name : "BREADCRUMB8"}
    ]
    const BreadCrumb = order.slice(0,  props.n)
    const { i18n } = useTranslation();
    return (
        <Row className={"new-breadcrumb"}>
            <Col>
                <Link to={".."} className="btn btn-outline mt-0">
                    <FontAwesomeIcon icon={['fas', 'house']} />{i18n.t('Introduction')}
                </Link><FontAwesomeIcon icon={['fas', 'angle-right']} /> {BreadCrumb.map((b,i) => <BreadCrumbItem key={i} item={b}/>)}
            </Col>
        </Row>
    );
};

export default BreadCrumb;
